import App from "./App.svelte";

let container = document.getElementById("cap_map_container");

const app = new App({
	target: container,
	props: {
		cp: container.dataset.cp,
		zoom: container.dataset.zoom,
		zoommax: container.dataset.zoommax,
		zoommin: container.dataset.zoommin,
		position: container.dataset.position,
		etat: container.dataset.etat,
		type: container.dataset.type
	}
});

export default app;
